import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getWhatsappAppointmentActions,
  getWhatsappStatusReasonAction,
  updateWhatsappAppoinmentStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import { ReasonTypeHAPortal, ReasonTypeHAProduct } from "./helper";
import { useState } from "react";

const WhatsappConfirmationPopup = ({
  isConfirmationPopup,
  setIsConfirmationPopup,
  params,
}) => {
  const dispatch = useDispatch();
  const [statusType, setStatusType] = useState(0);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const appoinmentReducer = useSelector((state) => state?.AppoinmentReducer);

  const handleSubmit = async () => {
    const temp = {
      appointmentId: isConfirmationPopup?.cardDetails?.appointmentId,
      dcConfirmationFlag: isConfirmationPopup?.DCConfirmationFlag,
      appointmentDate: isConfirmationPopup?.cardDetails?.appointmentDateTime,
      timeSlot: moment(
        isConfirmationPopup?.cardDetails?.appointmentDateTime
      ).format("YYYY-MM-DD hh:mm A"),
      appointmentStatusId:
        isConfirmationPopup?.cardDetails?.appointmentstatusid,
      validate: false,
      remarkId: statusType,
      valueType: isConfirmationPopup?.cardDetails?.valueType,
    };
    await dispatch(updateWhatsappAppoinmentStatusAction(temp, params));
    setStatusType(0);
    await dispatch(
      getWhatsappAppointmentActions(
        {
          page: globalReducer?.getCurrentPage,
          rows: 10,
        },
        params
      )
    );
    await handleClose();
  };

  const handleClose = () => {
    setIsConfirmationPopup(null);
    setStatusType(0);
  };

  return (
    <>
      <div className="modal-body modal-body-active-popup popup-text">
        {isConfirmationPopup?.message}
      </div>
      {isConfirmationPopup?.DCConfirmationFlag === "N" && (
        <div className="confirm_select_dropdown">
          <select
            className="form-select-admin"
            style={{ fontFamily: "Poppins" }}
            onChange={(e) => {
              setStatusType(0);
              dispatch(
                getWhatsappStatusReasonAction(
                  {
                    statusName: e.target.value ? e.target.value : null,
                    valueType: isConfirmationPopup?.cardDetails?.valueType,
                  },
                  params
                )
              );
            }}
          >
            <option value="">Reason Type</option>
            {isConfirmationPopup?.cardDetails?.valueType === "PORTAL"
              ? ReasonTypeHAPortal?.map((ele, index) => {
                  return (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  );
                })
              : ReasonTypeHAProduct?.map((ele, index) => {
                  return (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  );
                })}
          </select>
          <select
            className="form-select-admin"
            style={{ fontFamily: "Poppins", width: "100%" }}
            value={statusType}
            onChange={(e) => setStatusType(e.target.value)}
          >
            <option value={0}>Status Type</option>
            {appoinmentReducer?.getWhatsappStatusReason?.map((ele, index) => {
              return (
                <option key={index} value={ele?.statusId}>
                  {ele?.statusName}
                </option>
              );
            })}
          </select>
        </div>
      )}
      <div className="modal-footer modal-footer-active-popup">
        <button
          type="button"
          className="btn btn-primary noshow_disable"
          style={{ width: "90px" }}
          onClick={handleSubmit}
          disabled={
            isConfirmationPopup?.DCConfirmationFlag === "N" && statusType == 0
          }
        >
          Yes
        </button>
        <button
          type="button"
          className="btn btn-primary btn-logout-no"
          onClick={handleClose}
        >
          No
        </button>
      </div>
    </>
  );
};
export default WhatsappConfirmationPopup;
